// src/utils/c2paUtils.js

import { createC2pa } from 'c2pa';

const API_URL_EDITOR_SERVICE = process.env.REACT_APP_EDITOR_API_URL;
const API_URL_SBR = process.env.REACT_APP_SBR_API_URL;

const API_TOKEN = process.env.REACT_APP_SBR_API_KEY;

export const readC2PA = async (imageUrl) => {
  const c2pa = await createC2pa({
    wasmSrc: 'https://cdn.jsdelivr.net/npm/c2pa@0.30.8/dist/assets/wasm/toolkit_bg.wasm',
    workerSrc: 'https://cdn.jsdelivr.net/npm/c2pa@0.30.8/dist/c2pa.worker.min.js',
  });

  try {
    const { manifestStore, source } = await c2pa.read(imageUrl);
    console.log('manifestStore', manifestStore);

    return { success: manifestStore ? true : false, manifest: manifestStore, source: source };
  } catch (err) {
    console.error('Error reading image:', err);
    return { success: false };
  }
};

export const retrieveManifest = async (file) => {
  const formData = new FormData();

  const response = await fetch(file.sourceUrl);
  const blob = await response.blob();
  const _file = new File([blob], 'filename.' + blob.type.split('/')[1], { type: blob.type });

  formData.append('file', _file);

  const myHeaders = new Headers();
  myHeaders.append("Authorization", API_TOKEN);

  const requestOptions = {
    method: 'POST',
    body: formData,
    redirect: 'follow',
    headers: myHeaders,
  };

  const res = await fetch(`${API_URL_SBR}/matches/byContent?alg=com.digimarc.validate.1`, requestOptions);

  if (res.status !== 200) return { success: false };

  const resJson = await res.json();

  console.log('resJson', resJson);

  if (!resJson.matches || resJson.matches.length === 0) return { success: false };

  const manifestID = resJson.matches[0]?.manifestId;
  const originalAssetUrl = resJson.matches[0]?.originalImage;
  const pHash = resJson.matches[0]?.pHash;
  const expectedPHash = resJson.matches[0]?.expectedPHash;

  if (!manifestID) return { success: false };

  const headers = new Headers();
  headers.append('accept', 'application/json');
  headers.append('Authorization', API_TOKEN);

  const requestOptions2 = {
    method: 'GET',
    headers: headers,
    redirect: 'follow',
  };

  const manifestRes = await fetch(`${API_URL_SBR}/manifests/${encodeURIComponent(manifestID)}`, requestOptions2);

  if (manifestRes.status !== 200) return { success: false };

  const arrayBuffer = await manifestRes.arrayBuffer();
  const uint8Array = new Uint8Array(arrayBuffer);
  const string = new TextDecoder().decode(uint8Array);
  const json = JSON.parse(string);

  return {
    success: true,
    manifest: json,
    originalAssetUrl,
    pHash: pHash,
    expectedPHash: expectedPHash,
  };
};

export const compareManifests = async (file, imageUrl) => {
  const formData = new FormData();

  const response = await fetch(file.sourceUrl);
  const blob = await response.blob();
  const _file = new File([blob], 'filename.jpg', { type: blob.type });

  formData.append('image', _file);
  formData.append('imageUrl', imageUrl);

  const myHeaders = new Headers();
  myHeaders.append("Authorization", API_TOKEN);

  try {
    const response = await fetch(`${API_URL_EDITOR_SERVICE}/manifestDiff`, {
      method: 'POST',
      body: formData,
      headers: myHeaders,
    });

    if (response.status !== 200) {
      return true; // Assume no difference is detected if the request fails
    }

    const result = await response.json();

    if (Array.isArray(result) && result.length > 0) {
      return false; // Differences were found
    }

    return true; // No differences found
  } catch (error) {
    return true; // Assume no difference is detected in case of error
  }
};
